import React from "react";

export default function InstagramFeed() {
  return (
    <div className="instagram-feed-container" style={{ width: '100%', height: '880px', display: 'flex', justifyContent: 'center' }}>
      <iframe
        src="https://www.juicer.io/api/feeds/revista1986/iframe?per=15"
        frameBorder="0"
        className="juicer"
        style={{ width: '100%', height: '100%', border: 'none', borderRadius: '10px' }}
        allowFullScreen
        title="Instagram Feed"
      ></iframe>
    </div>
  );
} 